/* eslint-disable import/no-default-export */
import actions from './actions'
import mutations from './mutations'

const state = {
  shop: {
    id: 0,
    name: '',
    desc: '',
    url: '',
    bannerUrl: '',
    logoUrl: '',
    saleLimitAmount: 0,
    closeStoreTime: '', // 关店提示
    shopInvoiceWay: 0, // 店铺开票方式 1：线上开票  2：协商开票   0：无
    shopInvoiceWayText: '',
    isShowInvoiceWayText: 0, // 是否展示开票文案
    openInfo: {}, // 店铺状态
    invoiceTag: null // 店铺标签
  },
  personShopInfo: {
    isPersonShop: true,
    showPersonShopDetail: true,
    shopName: '',
    address: '',
    contactPhone: '',
    personalTip: ''
  },
  qualification: {
    showBizLicense: false,
    bizLicense: {
      companyName: '', // 公司名称
      code: '', // 营业执照代码
      pic: '' // 营业执照照片
    },
    otherLicenses: [],
    bizClass: []
  },

  class2List: [], // 二级菜单
  class2Index: -1, // 激活的二级菜单 Index
  class2Name: '全部',
  filterOpen: false, // 筛选框显示
  filterList: [], // 筛选-可筛选的所有菜品名称
  filterKey: [], // 筛选-选中的菜品名称
  brandList: [], // 筛选-可筛选的所有品牌
  selectedBrand: '', // 筛选-选中的品牌名称
  searchSkuList: [], // 活动列表数据
  hasFinished: false,
  pageNo: 1,
  loading: true,
  filterSort: false,
  minPrice: '',
  maxPrice: '',
  keyword: '',
  saleC1Id: '',
  clearStateData: false,
  queryData: {
    // bottomPrice: '', // 最小值
    // topPrice: '', // 最大值
    // salec1Id: '', // 一级分类id
    // saleC2Id: '', // 二级分类id
    // sortType: '', //  排序方式，1 价格升序 2 价格降序 不传默认排序
    // keyword: '', //  搜索关键字
    // brands: [], //  筛选品牌
    // biNames: [], //  筛选名称
    // promotionId: '', //  活动Id(或者优惠券id)
    // promoteRuleId: '', //  阶段规则id(当为阶段运营时必传)
    // promoteStageId: '', //  阶段id(当为阶段运营时必传)
    // promoteType: '' //  活动类型（1-优惠券去使用，2-满买赠去凑单
    // actionId: '' //  阶段运营 购物车、商品详情
  },
  riskInfo: {
    riskId: '',
    url: '',
    isShowVerifyModel: false
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
